import React, { useState } from "react";
import { useCountry } from "../../contexts/CountryContext";
import { Globe, ChevronDown } from "lucide-react";

const CountryToggle = () => {
  const { countryCode, setCountryCode, showToggle } = useCountry();
  const [open, setOpen] = useState(false);

  // On production hosts, the country is locked by domain (handyhub.co.nz / handyhubau.com.au)
  // and the toggle is hidden. It remains visible in preview/dev for QA.
  if (!showToggle) return null;

  return (
    <div className="country-toggle" data-testid="country-toggle">
      <button
        className="country-toggle-btn"
        onClick={() => setOpen(!open)}
        data-testid="country-toggle-btn"
      >
        <Globe size={16} />
        <span className="country-code">{countryCode}</span>
        <ChevronDown size={14} className={`toggle-chevron ${open ? 'open' : ''}`} />
      </button>
      {open && (
        <div className="country-dropdown" data-testid="country-dropdown">
          <button
            className={`country-option ${countryCode === 'NZ' ? 'active' : ''}`}
            onClick={() => { setCountryCode('NZ'); setOpen(false); }}
            data-testid="country-option-nz"
          >
            <span className="country-flag-option">&#127475;&#127487;</span>
            <span>New Zealand</span>
          </button>
          <button
            className={`country-option ${countryCode === 'AU' ? 'active' : ''}`}
            onClick={() => { setCountryCode('AU'); setOpen(false); }}
            data-testid="country-option-au"
          >
            <span className="country-flag-option">&#127462;&#127482;</span>
            <span>Australia</span>
          </button>
        </div>
      )}
    </div>
  );
};


export { CountryToggle };
